module.exports = __webpack_public_path__ + "img/reisen udongein inaba eternal_sc2.40a622b1.png";